import { Form, Formik } from "formik"

import { Button, FormField } from "~/ui-rtk/components/ui/controls"
import {
  ChipsFormField,
  KeywordsTooltip,
} from "../Onboarding/KeywordsForm/components"
import {
  SOS_FREE_MAX_CATEGORIES,
  SOS_FREE_MAX_COMPETITORS,
} from "~/ui-rtk/constants/sos"

import { useConnect } from "./connect"

const SosKeywordsForm = () => {
  const { isSubmitting, initialValues, validationSchema, updateKeywords } =
    useConnect()

  const preventEnterKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={updateKeywords}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ touched, errors }) => (
        <Form
          className="w-full"
          autoComplete="off"
          onKeyDown={preventEnterKeyDown}
        >
          <div className="flex flex-col items-center gap-4 mb-10">
            <FormField
              id="primaryBrandKeyword"
              type="text"
              label="Primary Brand Keyword"
              placeholder="Main brand keyword term"
              isError={Boolean(
                touched.primaryBrandKeyword && errors.primaryBrandKeyword,
              )}
              appendNode={
                <KeywordsTooltip content="This should be the single brand term most likely to pair with your category terms." />
              }
              classes={{ label: "text-3.5 font-semibold" }}
            />
            <ChipsFormField
              id="categoryKeywords"
              label={`Category Keywords (up to ${SOS_FREE_MAX_CATEGORIES})`}
              isError={Boolean(
                touched.categoryKeywords && errors.categoryKeywords,
              )}
              placeholder="Your product category terms"
            />
            <ChipsFormField
              id="competitorsKeywords"
              label={`Competitor Keywords (up to ${SOS_FREE_MAX_COMPETITORS})`}
              isError={Boolean(
                touched.competitorsKeywords && errors.competitorsKeywords,
              )}
              placeholder="Your competitors' brand terms"
            />
          </div>
          <Button
            type="submit"
            className="mx-auto sm:max-w-64 w-full"
            isLoading={isSubmitting}
          >
            Build my report
          </Button>
        </Form>
      )}
    </Formik>
  )
}

export default SosKeywordsForm
